import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { ConditionsBox } from './components/ConditionsBox';
import { LegalExampleText } from './components/LegalExampleText';

/**
 * Landing page variant: the grey conditions box plus the 2/3 example text
 * outside of the box. Stacked on mobile (example first), side by side from `md`
 * (box left).
 */
export const LegalTextGoogleWithExample = () => (
  <Box sx={{ py: { xs: 2, md: 4 } }}>
    <Grid container spacing={2}>
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{ order: { md: 2 }, display: 'flex', alignItems: 'center' }}
      >
        <LegalExampleText />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }} sx={{ order: { md: 1 } }}>
        <ConditionsBox />
      </Grid>
    </Grid>
  </Box>
);
